import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	devResetOpcs : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.post('dev/reset-opcs', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	devResetOpcls : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.post('dev/reset-opcls', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	devCompleteAllLessons : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.post('dev/complete-all-lessons', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	devResetAllLessons : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.post('dev/reset-all-lessons', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},
	devResetStatus : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.post('dev/reset-status', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}

	
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/DevelopmentModule.js